import { toast } from "react-toastify";
import { apiURL } from "../../config";

// Who has access to a decision and what the current user may do
export async function getDecisionAccess(axiosPrivate, id) {
	const res = await axiosPrivate.get(`${apiURL}/decision/${id}/access.json`);
	return res.data;
}

export async function getDecisionStatuses(axiosPrivate) {
	const res = await axiosPrivate.get(`${apiURL}/decision/statuses.json`);
	return res.data;
}

export async function getOrganizationUsers(axiosPrivate) {
	const res = await axiosPrivate.get(`${apiURL}/user.json`);
	return Array.isArray(res.data) ? res.data : [];
}

// All units of the organization, flattened
export async function getOrganizationUnits(axiosPrivate) {
	const res = await axiosPrivate.get(`${apiURL}/unit/list.json`);
	const flatten = (units) => units.flatMap((unit) => [{ id: unit.id, name: unit.name }, ...flatten(unit.children || [])]);
	return Array.isArray(res.data) ? flatten(res.data) : [];
}

function errorMessage(err, fallback) {
	return err?.response?.data?.message || fallback;
}

async function accessRequest(request, success, failure) {
	try {
		const res = await request();
		toast.success(success);
		return res.data;
	} catch (err) {
		toast.error(errorMessage(err, failure));
		throw err;
	}
}

export function setDecisionOwner(axiosPrivate, id, userId) {
	return accessRequest(
		() => axiosPrivate.put(`${apiURL}/decision/${id}/owner.json`, { user: userId }),
		"Ownership handed over",
		"Ownership could not be handed over"
	);
}

export function addDecisionCollaborator(axiosPrivate, id, userId) {
	return accessRequest(
		() => axiosPrivate.post(`${apiURL}/decision/${id}/collaborator/${userId}.json`),
		"Collaborator added",
		"Collaborator could not be added"
	);
}

export function removeDecisionCollaborator(axiosPrivate, id, userId) {
	return accessRequest(
		() => axiosPrivate.delete(`${apiURL}/decision/${id}/collaborator/${userId}.json`),
		"Collaborator removed",
		"Collaborator could not be removed"
	);
}

export function addDecisionReader(axiosPrivate, id, userId) {
	return accessRequest(
		() => axiosPrivate.post(`${apiURL}/decision/${id}/reader/${userId}.json`),
		"Reader added",
		"Reader could not be added"
	);
}

export function removeDecisionReader(axiosPrivate, id, userId) {
	return accessRequest(
		() => axiosPrivate.delete(`${apiURL}/decision/${id}/reader/${userId}.json`),
		"Reader removed",
		"Reader could not be removed"
	);
}

export function addDecisionReaderUnit(axiosPrivate, id, unitId) {
	return accessRequest(
		() => axiosPrivate.post(`${apiURL}/decision/${id}/organization-unit/${unitId}.json`),
		"Unit added as reader",
		"Unit could not be added"
	);
}

export function removeDecisionReaderUnit(axiosPrivate, id, unitId) {
	return accessRequest(
		() => axiosPrivate.delete(`${apiURL}/decision/${id}/organization-unit/${unitId}.json`),
		"Unit removed",
		"Unit could not be removed"
	);
}

export function changeDecisionStatus(axiosPrivate, id, statusId) {
	return accessRequest(
		() => axiosPrivate.put(`${apiURL}/decision/status/edit/${id}.json`, { status: statusId }),
		"Status changed",
		"Status could not be changed"
	);
}
